/**
 * Faded card at the insertion index.
 * Owns all destination spacing — sortable transforms must stay disabled
 * (see KanbanSortableItem) so we never get overlapping ghosts + double gaps.
 */

import type { ReactNode } from 'react';
import { cn } from '@/utils/cn';
import { kanbanFadedCardPlaceholderClass } from './Kanban.styles';

export function KanbanFadedCardPlaceholder({
  children,
  className,
  flipKey,
  flipFrom,
}: {
  children: ReactNode;
  className?: string;
  /** `data-kanban-flip` key so the placeholder slides with its neighbors. */
  flipKey?: string;
  /** FLIP key to slide from when the placeholder first appears. */
  flipFrom?: string;
}) {
  return (
    <div
      role="status"
      aria-label="Drop position"
      className={cn(kanbanFadedCardPlaceholderClass, className)}
      data-kanban-faded-placeholder=""
      data-kanban-flip={flipKey}
      data-kanban-flip-from={flipFrom}
    >
      {children}
    </div>
  );
}
